"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get tableReadBuilder () {
        return tableReadBuilder;
    },
    get tableViewBuilder () {
        return tableViewBuilder;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const tableReadBuilder = (0, _apiv3datatransformationbuilder.builderGenerator)({
    allowed: [
        'id',
        'title',
        'meta',
        'description',
        'source_id',
        'base_id',
        'fk_workspace_id'
    ],
    orderProps: [
        'id',
        'title',
        'meta',
        'description',
        'source_id',
        'base_id',
        'workspace_id'
    ],
    mappings: {
        fk_workspace_id: 'workspace_id'
    },
    transformFn: (table)=>{
        // if description is empty, set it to undefined
        if (table.description === '') {
            table.description = undefined;
        }
        return table;
    },
    meta: {
        snakeCase: true,
        metaProps: [
            'meta'
        ],
        allowed: [
            'icon_color',
            'icon'
        ]
    }
});
const tableViewBuilder = (0, _apiv3datatransformationbuilder.builderGenerator)({
    allowed: [
        'id',
        'title',
        'type'
    ],
    transformFn: (view)=>{
        return _extends({}, view, {
            view_type: _nocodbsdk.viewTypeAlias[view.type],
            type: undefined
        });
    }
});
